import React from "react";
import { DisplayWithIcon } from "../shared/Typography/types";
import { GetTypographyContent } from "../shared/Typography/Typography";
import {
  TestResultIconAndTypography,
  TestResultsIcon,
} from "./TestResults.styles";

export const TestResultsRhdInfo = (
  displayWithIcon: DisplayWithIcon,
  label = "RhD/Fetal Antigen",
): React.ReactElement => (
  <>
    {GetTypographyContent({
      content: label,
      size: "large",
      textColor: "greyMedium",
    })}
    <TestResultIconAndTypography>
      <TestResultsIcon
        marginLeft={
          (displayWithIcon.rawDisplay || displayWithIcon.display) ===
          "See Report"
        }
      >
        {displayWithIcon.icon}
      </TestResultsIcon>
      {GetTypographyContent({
        content: displayWithIcon.display,
        size: "medium",
        textColor: "greyMedium",
      })}
    </TestResultIconAndTypography>
  </>
);
